import React from 'react';
import { useTable } from '../TableContext';
import { cn } from '../../../../utils/cn';

interface TableEmptyStateProps {
  title?: string;
  message?: string;
  className?: string;
  render?: (props: { columns: number }) => React.ReactNode;
}

export function TableEmptyState({
  title = 'No data available',
  message = 'There are no records to display.',
  className,
  render,
}: TableEmptyStateProps) {
  const { table } = useTable();
  const columns = table.getAllColumns().length;

  if (render) {
    return (
      <tbody>
        <tr>
          <td colSpan={columns}>{render({ columns })}</td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      <tr>
        <td
          colSpan={columns}
          className={cn('w-full px-6 py-8 text-center', className)}
        >
          <div className="flex flex-col items-center justify-center">
            <svg
              className="h-12 w-12 text-gray-400 dark:text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              />
            </svg>
            <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-gray-100">
              {title}
            </h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {message}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  );
}
